module.exports = __webpack_public_path__ + "static/media/new-arrival-bg-right.c3c49fd8.png";